import React, { useState } from 'react';
import { ListStores } from '../components/ListStores';
import { AddType } from '../components/AddType';
import { ManualAddStore } from '../components/Shop/ManualAddStore';
import { AddByPhone } from '../components/Shop/AddByPhone';
import logoIcon from '../assets/logo/icon.svg';
import '../assets/Shops.css';
import '../App.css';
import { useData } from '../context/DataContext';

const RefreshIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 4v6h-6"></path>
    <path d="M1 20v-6h6"></path>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
  </svg>
);

export const Shops: React.FC = () => {
  const [view, setView] = useState<'list' | 'addType' | 'addPhone' | 'addManual'>('list');
  const { refreshStores, storesLoading, stores } = useData();
  const [refreshing, setRefreshing] = useState(false);

  const handleManualRefresh = async () => {
    setRefreshing(true);
    await refreshStores();
    setRefreshing(false);
  };

  return (
    <div className="page">
      <header className="page__head">
        <img src={logoIcon} alt="" className="page__logo" onError={(e) => e.currentTarget.style.display = 'none'} />
        <div className="page__titles">
          <h1 className="page__title">Shops</h1>
          <p className="page__sub">{stores.length} registered</p>
        </div>
        {view === 'list' && (
          <div className="page__actions">
            <button
              className={`icon-btn ${refreshing || storesLoading ? 'is-spinning' : ''}`}
              onClick={handleManualRefresh}
              disabled={refreshing || storesLoading}
              aria-label="Refresh shops"
            >
              <RefreshIcon />
            </button>
          </div>
        )}
      </header>

      <div>
        {view === 'list' && (
          <ListStores onAdd={() => setView('addType')} />
        )}
        {view === 'addType' && (
          <AddType
            onAddPhone={() => setView('addPhone')}
            onAddManual={() => setView('addManual')}
            onBack={() => setView('list')}
          />
        )}
        {view === 'addPhone' && (
          <AddByPhone onAdd={() => setView('list')} />
        )}
        {view === 'addManual' && (
          <ManualAddStore onAdd={() => setView('list')} />
        )}
      </div>
    </div>
  );
};